import { render, staticRenderFns } from "./admin_user.vue?vue&type=template&id=72b14513&scoped=true&"
import script from "./admin_user.vue?vue&type=script&lang=ts&"
export * from "./admin_user.vue?vue&type=script&lang=ts&"
import style0 from "./admin_user.vue?vue&type=style&index=0&id=72b14513&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b14513",
  null
  
)

export default component.exports